import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	alpha,
	Theme,
} from '@mui/material/styles';
// Import enumerations

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		inputAddressesSelectionList_container: {

		},
		inputAddressesSelectionList_headerMessage: {
			color: theme.palette.info.main,
			fontWeight: theme.typography.fontWeightBold as any,
			fontSize: theme.typography.h6.fontSize,
			padding: theme.spacing(0, 1.5),
			lineHeight: theme.spacing(3.5)
		},
		inputAddressesSelectionList_headerMessageDisabled: {
			color: theme.palette.info[300],
			fontWeight: theme.typography.fontWeightBold as any,
			fontSize: theme.typography.h6.fontSize,
			padding: theme.spacing(0, 1.5),
			lineHeight: theme.spacing(3.5)
		},
		inputAddressesSelectionList_headerMessageWrapper: {
			width: '100%',
			display: 'flex',
			flexWrap: 'wrap',
			'&:focus': {
				outline: `1px dotted ${theme.palette.grey[500]}`,
			}
		},
		inputAddressesSelectionList_wholeRow: {
			width: '100%',
			display: 'flex',
			flexWrap: 'wrap',
		},
		inputAddressesSelectionList_wholeRowColumn: {
			padding: theme.spacing(4, 1.5, 3, 1.5),
			flex: '1 0',
			minWidth: '300px',
			display: 'flex',
			flexDirection: 'column',
		},
		inputAddressesSelectionList_addressBox: {
			border: `2px solid ${theme.palette.grey[400]}`,
			padding: theme.spacing(2, 3),
			borderRadius: theme.shape.borderRadius,
			cursor: 'pointer',
			transition: '300ms ease-in-out',
			flex: '1 0',
			'&:hover, &:focus': {
				outline: 'none',
				transition: '300ms ease-in-out',
				border: `2px solid ${theme.palette.grey[500]}`,
				backgroundColor: alpha(theme.palette.common.black, 0.05),
				boxShadow: `2px 2px 8px ${alpha(theme.palette.common.black, 0.16)}`,
			}
		},
		inputAddressesSelectionList_addressBoxSelected: {
			border: `2px solid ${theme.palette.grey[500]}`,
			backgroundColor: alpha(theme.palette.common.black, 0.05),
			boxShadow: `2px 2px 8px ${alpha(theme.palette.common.black, 0.16)}`,
			'&:hover, &:focus': {
				transition: '300ms ease-in-out',
				boxShadow: `2px 2px 10px ${alpha(theme.palette.common.black, 0.35)}`,
			}
		},
		inputAddressesSelectionList_addressBoxDisabled: {
			border: `2px solid ${theme.palette.grey[200]}`,
			padding: theme.spacing(2, 3),
			borderRadius: theme.shape.borderRadius,
			'&:focus': {
				outline: `1px dotted ${theme.palette.grey[500]}`,
			}
		},
		inputAddressesSelectionList_addressBoxSelectedDisabled: {
			border: `2px solid ${theme.palette.grey[300]}`,
			backgroundColor: alpha(theme.palette.common.black, 0.03),
			boxShadow: `2px 2px 8px ${alpha(theme.palette.common.black, 0.10)}`,
		},
		inputAddressesSelectionList_addressBoxLine: {
			color: theme.palette.info.main,
			padding: theme.spacing(1, 0),
			fontSize: theme.typography.h6.fontSize,
		},
		inputAddressesSelectionList_addressBoxLineDisabled: {
			color: theme.palette.info[300],
			padding: theme.spacing(1, 0),
			fontSize: theme.typography.h6.fontSize,
		},
		inputAddressesSelectionList_addressSelectionButton: {
			marginTop: theme.spacing(3),
		},
		inputAddressesSelectionList_helperText: {
			padding: theme.spacing(0, 0, 0, 1.5),
		},
	});
});

export default useStyles;
